export const localStorageItems = {
    jwt_token: "x-auth-token",
    ACCEPT_LANGUAGE: "accept-language",
    COUNTRY_DATA: "country-data",
    STATE_DATA: "state-data",
    SKILL_DATA: "skills"
}